import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="checkbox-toggle"
// 通用的 checkbox toggle controller，用於根據 checkbox 的勾選狀態來顯示/隱藏目標元素
//
// 使用方式：
// %div{ data: { controller: 'checkbox-toggle' } }
//   = f.check_box :field, data: { action: 'change->checkbox-toggle#toggle' }
//   %div{ data: { checkbox_toggle_target: 'toggleable' } }
//     要被控制顯示/隱藏的內容
//
// 進階用法（反向控制，勾選時隱藏）：
// %div{ data: { controller: 'checkbox-toggle', checkbox_toggle_reverse_value: 'true' } }
//   = f.check_box :field, data: { action: 'change->checkbox-toggle#toggle' }
//   %div{ data: { checkbox_toggle_target: 'toggleable' } }
//     要被控制顯示/隱藏的內容
export default class extends Controller {
  static targets = ["toggleable"]
  static values = {
    reverse: Boolean  // 是否反向控制（true: 勾選時隱藏，false: 勾選時顯示）
  }

  // Called when controller is connected
  connect() {
    this.toggle()
  }

  // Called when checkbox is changed
  toggle(event) {
    const checkbox = event ? event.target : this.element.querySelector('input[type="checkbox"]')

    if (!checkbox || !this.hasToggleableTarget) return

    const shouldShow = this.reverseValue ? !checkbox.checked : checkbox.checked

    this.toggleableTargets.forEach(target => {
      if (shouldShow) {
        target.classList.remove("d-none")
      } else {
        target.classList.add("d-none")
        // 隱藏時，清空該區塊內所有 checkbox 的勾選狀態
        this._uncheckAll(target)
      }
    })
  }

  // 取消勾選目標元素內的所有 checkbox
  _uncheckAll(target) {
    const checkboxes = target.querySelectorAll('input[type="checkbox"]')
    checkboxes.forEach(checkbox => {
      checkbox.checked = false
    })
  }
}
